import React from "react";
const NotificationsContext = React.createContext({});
export const UnreadContext = React.createContext(0);
export default NotificationsContext;
